"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const picker_1 = require("@react-native-picker/picker");
const styles_1 = __importDefault(require("../../styles/styles"));
const searchBarStyles_1 = __importDefault(require("./searchBarStyles"));
const themes_1 = __importDefault(require("../../styles/themes"));
const colors_1 = __importDefault(require("../../styles/colors"));
const searchBarConstants_1 = require("./searchBarConstants");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const callSlice_1 = require("../../features/call/callSlice");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const utils_1 = require("../../utils/utils");
const DefaultProps = {
    parameters: searchBarConstants_1.CALL_LOG_SEARCH_PARAMETERS,
};
const SearchBar = ({ parameters, onSearch }) => {
    const dispatch = useAppDispatch_1.default();
    const { searchQuery } = useAppSelector_1.default((state) => ({
        searchQuery: state.call.searchQuery,
    }));
    const initialSearchQuery = searchQuery && typeof searchQuery.value !== 'undefined' ? searchQuery.value.toString() : '';
    const [query, setQuery] = react_1.useState(initialSearchQuery);
    const [selectedParameter, setSelectedParameter] = react_1.useState(searchQuery ? searchQuery.parameter : parameters[0]);
    const onValueChange = (value) => {
        setSelectedParameter(value);
    };
    const onIconPress = () => {
        const payload = { parameter: selectedParameter, value: query };
        dispatch(callSlice_1.updateSearchQuery(payload));
        onSearch(payload);
    };
    return (react_1.default.createElement(react_native_1.View, { style: [
            styles_1.default.flexDirectionRow,
            styles_1.default.marginBottomTen,
            styles_1.default.alignItemsCenter,
            styles_1.default.flexWrap,
        ] },
        react_1.default.createElement(react_native_paper_1.Searchbar, { placeholder: "Search", onChangeText: setQuery, value: query, onIconPress: onIconPress, iconColor: colors_1.default.BLUE_2, theme: themes_1.default.textInput, style: [styles_1.default.whiteBackground, styles_1.default.textColorBlack, searchBarStyles_1.default.searchBar] }),
        react_1.default.createElement(picker_1.Picker, { selectedValue: selectedParameter, onValueChange: onValueChange, style: [styles_1.default.textInput, searchBarStyles_1.default.picker], itemStyle: [styles_1.default.textTitle] }, !!parameters &&
            parameters.map((parameter) => (react_1.default.createElement(picker_1.Picker.Item, { label: `Search by ${utils_1.formatTitle(parameter)}`, key: parameter, value: parameter }))))));
};
SearchBar.defaultProps = DefaultProps;
exports.default = SearchBar;
